// extracted by mini-css-extract-plugin
export default {"teamLabel":"Teams_teamLabel__aDbuF","teamLabelText":"Teams_teamLabelText__Xottu"};